import React, { useEffect, useState } from "react";
import {
  FlexContainer,
  Divider,
  Link,
} from "../../constants/assets/containers";
import Modal from "sushiweb/Modal";
import { DocImg } from "../../views/QcDetails";
import variables from "../../constants/assets/variables";
import Button from "sushiweb/Button";
import { DocImgContainer } from "./QcDriverBasicDetailsEdit";
import styled from "styled-components";

const RiderCard = (riderData) => {
  let profile_pic_url = riderData.profile_pic_url;
  let city = riderData.city;
  return (
    <div>
      <FlexContainer>
        <div class="Responsive-Borders-Classes">
          <p className="section-heading" style={{ textAlign: "center" }}>
            <b>{riderData.heading}</b>
          </p>
          <DocImg src={profile_pic_url} cursor="pointer" alt="" />
          <div alignItems="center">
            <p>
              City : <b>{city}</b>
            </p>
          </div>
        </div>
      </FlexContainer>
    </div>
  );
};
const sortingIndex = {
  terminated: 1,
  disabled: 2,
  onboarding: 3,
  open: 4,
  active: 5,
};

const handleRedirection = (feId) => {
  window.open(
    window.location.origin + `/delivery-drivers/${feId}/details`,
    "_blank"
  );
};

const QcDeviceId = ({
  currentActiveFeId,
  faceMatch,
  phoneMatch,
  deviceMatch,
  riderDataToShow,
  handleVerifiedChange,
  qcDetails,
  handleSave,
  item,
  handleRejectionReasonChange,
}) => {
  const isTerminated = qcDetails.driver_lifecycle_status === "terminated";
  const [riderData, setRiderData] = useState([]);
  const [matchData, setMatchData] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [modalContent, setModalContent] = useState("");

  const Slide = ({ matchData }) => {
    let fe_id = matchData.fe_id;
    let heading = matchData.heading;
    let profile_pic_url = matchData.profile_pic_url;
    let city = matchData.city;
    let lifecycleStatus = matchData.lifecycle_status;
    let is_referee = matchData.is_referee;

    return (
      <div>
        <FlexContainer>
          <div class="Responsive-Borders-Classes">
            <div style={{ textDecoration: "underline" }}>
              <Link onClick={() => handleRedirection(fe_id)}>
                <p className="section-heading">{heading}</p>
              </Link>
            </div>

            <DocImg
              onClick={() => {
                if (isTerminated) return;
                handleDocClick({
                  heading: heading,
                  fe_id: fe_id,
                  profile_pic_url: profile_pic_url,
                  city: city,
                  lifecycleStatus: lifecycleStatus,
                  is_referee: is_referee,
                });
              }}
              src={profile_pic_url}
              cursor="pointer"
              alt=""
            />
            <div alignItems="center">
              <p>
                City : <b>{city}</b>
              </p>
              <p>
                Status : <b>{lifecycleStatus}</b>
              </p>
              {is_referee && (
                <p style={{ marginTop: "10px", background: "#D3D3D3" }}>
                  <center>
                    <b>Referee driver</b>
                  </center>
                </p>
              )}
            </div>
          </div>
        </FlexContainer>
      </div>
    );
  };

  const getObjectToRender = (matchType, matchData) => {
    var dataToShow = [];
    matchData.forEach((data) => {
      if (matchType.length == 0) {
        dataToShow.push({
          heading: "QC Rider : " + currentActiveFeId,
          city: data.city,
          profile_pic_url: data.profile_pic_url,
        });
      } else {
        dataToShow.push({
          heading: matchType + " with: " + data.fe_id,
          city: data.city,
          profile_pic_url: data.profile_pic_url,
          lifecycle_status: data.lifecycle_status,
          fe_id: data.fe_id,
          is_referee: data.is_referee,
        });
      }
    });
    return dataToShow;
  };

  useEffect(() => {
    const faceMatchDataToShow = getObjectToRender("Device linked", faceMatch);
    const otherFaceMatchData = faceMatchDataToShow.filter(
      (item) => !item.is_referee
    );
    const refereeFaceMatchData = faceMatchDataToShow.filter(
      (item) => item.is_referee
    );

    const sortedFaceMatchData = [
      ...refereeFaceMatchData.sort(
        (a, b) =>
          sortingIndex[a.lifecycle_status] - sortingIndex[b.lifecycle_status]
      ),
      ...otherFaceMatchData.sort(
        (a, b) =>
          sortingIndex[a.lifecycle_status] - sortingIndex[b.lifecycle_status]
      ),
    ];
    console.log("[sortedFaceMatchData]" + faceMatch);

    var matchDataToShow = [
      ...sortedFaceMatchData,
      ...getObjectToRender("Phone Match", phoneMatch).sort(
        (a, b) =>
          sortingIndex[a.lifecycle_status] - sortingIndex[b.lifecycle_status]
      ),
      ...getObjectToRender("Device Match", deviceMatch).sort(
        (a, b) =>
          sortingIndex[a.lifecycle_status] - sortingIndex[b.lifecycle_status]
      ),
    ];

    var riderDataCard = getObjectToRender("", riderDataToShow);
    setRiderData(riderDataCard[0]);
    setMatchData(matchDataToShow);
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDocClick = (data) => {
    setModalContent(data);
    setShowModal(true);
  };

  const handleReject = (rejection_reason) => {
    handleRejectionReasonChange("device_linkages", rejection_reason, [
      item,
      "basic_details",
    ]);
    handleVerifiedChange(item, false, "basic_details");
    setShowModal(false);
    handleSave();
  };
  return (
    <div>
      <div style={{ maxWidth: "auto", paddingBottom: "50px", height: "250px" }}>
        <div style={{ display: "inline-block", width: "20%", float: "left" }}>
          {RiderCard(riderData)}
        </div>
        <div
          style={{
            display: "inline-block",
            width: "10%",
            float: "left",
            paddingLeft: "50px",
          }}
        >
          <Divider height="250px" width="5px" color={variables.grey} />
        </div>
        <div
          style={{
            display: "inline-block",
            width: "70%",
            float: "left",
            paddingLeft: "25px",
            marginBottom: "10px",
          }}
        >
          <DocImgContainer>
            {matchData?.map((element) => {
              return <Slide matchData={element} key={element.fe_id} />;
            })}
          </DocImgContainer>
        </div>
        <div style={{ clear: "both" }} />
      </div>
      <Modal
        className={"full-height-modal"}
        visible={showModal}
        onClose={handleClose}
        showCloseIcon={true}
        slideOnMobile
        isCentered
        padding="2rem"
        preventFocus
      >
        <div
          style={{
            maxWidth: "auto",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NoteStyled>The rider will be terminated upon rejection.</NoteStyled>
          <p
            className="row-heading"
            style={{ textAlign: "left", padding: "5px" }}
          >
            Device Linkages
          </p>
          <Divider color={variables.grey} marginBottom="5px" />
          <FlexContainer align="flex-start" marginTop="5px">
            <div
              style={{
                alignContent: "center",
                justifyContent: "center",
                padding: "5px",
                float: "left",
              }}
            >
              <div class="Responsive-Borders-Classes">
                <p
                  className="section-heading"
                  style={{ textAlign: "center", padding: "10px" }}
                >
                  <b>QC Rider: {currentActiveFeId}</b>
                </p>
                <DocImg
                  style={{ height: 300, width: 300, responsive: true }}
                  src={riderData.profile_pic_url}
                  cursor="pointer"
                  alt=""
                />
                <div alignItems="center">
                  <p>
                    City : <b>{riderData.city}</b>
                  </p>
                </div>
              </div>
            </div>
            <div style={{ float: "left", marginTop: "15px" }}>
              <Divider height="350px" width="5px" color={variables.grey} />
            </div>
            <div
              style={{
                alignContent: "center",
                justifyContent: "center",
                padding: "5px",
                float: "left",
              }}
            >
              <div class="Responsive-Borders-Classes">
                <p
                  className="section-heading"
                  style={{
                    textAlign: "center",
                    padding: "10px",
                    textDecoration: "underline",
                  }}
                >
                  <Link onClick={() => handleRedirection(modalContent.fe_id)}>
                    <p className="section-heading">{modalContent.heading}</p>
                  </Link>
                </p>
                <DocImg
                  style={{ height: 300, width: 300, responsive: true }}
                  src={modalContent.profile_pic_url}
                  cursor="pointer"
                  alt=""
                />
                <div alignItems="center">
                  <p>
                    City : <b>{modalContent.city}</b>
                  </p>
                  <p>
                    Status : <b>{modalContent.lifecycleStatus}</b>
                  </p>

                  {modalContent.is_referee && (
                    <p style={{ marginTop: "10px", background: "#D3D3D3" }}>
                      <center>
                        <b>Referee driver</b>
                      </center>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </FlexContainer>
          <div
            class="Responsive-Borders-Classes"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <Button
              size="medium"
              className="sushi-btn"
              onClick={() => {
                handleReject(modalContent.heading);
              }}
            >
              Reject
            </Button>
          </div>
          <p className="section-heading" style={{ textAlign: "center" }}>
            <b>
              Select on the QC reject only when the device is linked with the
              rider.
            </b>
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default QcDeviceId;

export const NoteStyled = styled.div`
  color: #f00;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #f00;
  border-radius: 5px;
  background-color: rgb(241, 229, 229);
  margin-top: 10px;
`;
